
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'documents-public-ui',
  currentProjectVersion: 'static-1.35169',
  depVersions: {
  "documents-public-ui": "static-1.35169",
  "atom": "static-1.5354",
  "autolinker": "static-3.11",
  "avatar-components": "static-1.2762",
  "client-types": "static-1.496",
  "cssUtils": "static-1.888",
  "customer-data-filters-ui": "static-1.40823",
  "customer-data-objects": "static-1.7956",
  "customer-data-property-utils": "static-1.8370",
  "documents-lib": "static-1.35174",
  "emoji-mart": "static-3.4",
  "flux-actions": "static-1.364",
  "FormsCommonComponents": "static-1.86506",
  "FormUrlGenerator": "static-2.4995",
  "foundations-theming-specialty": "static-1.2455",
  "googlemaps-react-wrapper": "static-1.3",
  "head-dlb": "static-1.5007",
  "highcharts": "static-8.108",
  "hs-lodash": "static-4.45",
  "hs-promise-utils": "static-1.5865",
  "hs-test-utils": "static-1.8298",
  "hub-http": "static-1.6481",
  "hubspot-dlb": "static-2.1882",
  "HubStyle": "static-2.12063",
  "HubStyleTokens": "static-2.11756",
  "I18n": "static-7.1667",
  "icons": "static-2.677",
  "jasmine-immutable": "static-1.3289",
  "jasmine-runner": "static-1.6721",
  "js-cookie": "static-1.18",
  "laboratory-lib": "static-3.7420",
  "lodash": "static-1.3",
  "PatternValidationJS": "static-1.3163",
  "pdf-js": "static-2.49",
  "property-translator": "static-1.5666",
  "quartz": "static-1.7413",
  "react": "static-7.192",
  "react-dlb": "static-1.88",
  "react-dnd": "static-3.19",
  "react-dnd-html5-backend": "static-3.7",
  "react-immutable-proptypes": "static-2.8",
  "react-input-autosize": "static-2.17",
  "react-redux": "static-7.75",
  "react-rhumb": "static-1-fkhalid-delete-fcp-cls-subscribers.4",
  "react-select-plus": "static-1.109",
  "react-utils": "static-2.5534",
  "react-virtualized": "static-2.104",
  "reference-resolvers": "static-1.8450",
  "reference-resolvers-lite": "static-1.8372",
  "reporting-data": "static-1.68696",
  "reporting-reports": "static-1.68373",
  "reporting-snowflake": "static-1.57313",
  "reporting-testing-lib": "static-1.10629",
  "reporting-visualizations": "static-1.60771",
  "reselect": "static-3.9",
  "sales-content-partitioning": "static-1.9219",
  "sanitize": "static-1.4742",
  "sanitize-text": "static-1.8421",
  "SharedI18nStrings": "static-1.182",
  "SharedLegalStrings": "static-1.2016",
  "signup-constants": "static-1.19553",
  "signup-ui-url-generator": "static-2.8330",
  "StyleGuideUI": "static-3.499",
  "superstore": "static-1.5026",
  "tinymce": "static-6.5",
  "transmute": "static-2.85",
  "ui-addon-draggable": "static-3.5026",
  "ui-addon-form-validation": "static-1.11251",
  "ui-asset-management-lib": "static-1.11366",
  "ui-images": "static-2.1238",
  "UIComponents": "static-3.8702",
  "usage-tracker": "static-1.7624",
  "usage-tracker-container": "static-1.7614",
  "usage-tracker-core": "static-1.7474",
  "viral-links-lib": "static-1.7344",
  "webpack-env": "static-1.54",
  "data-fetching-client": "static-1.9926",
  "foundations-components": "static-1-ech-accordiontransition-jank.20",
  "immutable": "static-2.83",
  "isMobile": "static-1.7",
  "PortalIdParser": "static-2.404",
  "quartz-config": "static-1.1191",
  "quartz-core": "static-1.6632",
  "quick-fetch": "static-1.4109",
  "raven": "static-3.5925",
  "redux": "static-4.76",
  "redux-thunk": "static-2.77",
  "rpc-client-utils": "static-1.4933",
  "ui-addon-i18n": "static-1.11414",
  "ui-addon-upgrades": "static-9.18342",
  "enviro": "static-4.455",
  "hs-promise-rejection-tracking": "static-1.5587",
  "raven-hubspot": "static-1.6232",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "hubspot-url-utils": "static-1.4297",
  "metrics-js": "static-1.9867",
  "styled-components": "static-2.95",
  "bend-plugin-trellis-migration": "static-1.3596",
  "moment": "static-3.26",
  "react-dom": "static-7.85",
  "bend-plugin-quartz": "static-1.3690",
  "quartz-webpack": "static-1.3637",
  "foundations-assets": "static-1.5151",
  "foundations-theming": "static-1.4739",
  "hub-http-janus": "static-1.873",
  "hub-http-shared-msw-handlers": "static-1.10566",
  "hubspotter-http": "static-1.4842",
  "sassPrefix": "static-1.163",
  "conversations-skeleton-state": "static-1.7514",
  "crm-message-bus": "static-1.43695",
  "customer-data-filters-ui-msw-helpers": "static-1.23258",
  "customer-data-objects-ui-components": "static-1.13299",
  "customer-data-reference-ui-components": "static-1.13447",
  "customer-data-ui-utilities": "static-1.10097",
  "events-data-lib": "static-1.510",
  "framework-builder-read-service-client": "static-1.4199",
  "hs-resources": "static-1.459",
  "immer": "static-1.94",
  "inbound-db-meta-service-client": "static-1.3718",
  "inbound-db-properties-service-client": "static-1.4034",
  "multi-account-reference-resolvers": "static-1.1268",
  "onboarding-scopes": "static-1.6721",
  "onboarding-tours": "static-1.17072",
  "pulse": "static-1.896",
  "reporting-datasets-permissions-lib": "static-1.14411",
  "stylex": "static-1.38",
  "trellis-assets": "static-1.2548",
  "trellis-components": "static-1.2567",
  "trellis-theming": "static-1.1237",
  "ui-addon-teams": "static-1.21875",
  "quartz-auth": "static-1.1088",
  "ui-business-units-lib": "static-1.9355",
  "usage-tracker-session-replay": "static-1.5310",
  "ai-components-ui-library": "static-1.9650",
  "ContentUtils": "static-1.69070",
  "customer-data-properties": "static-1.52496",
  "forms-ai-lib": "static-1.4721",
  "forms-utils-lib": "static-1.13053",
  "foundations-components-test-utils": "static-1-ech-accordiontransition-jank.20",
  "react-dnd-compat": "static-1.4885",
  "react-tinymce": "static-1.55922",
  "tinymce-config": "static-2.55048",
  "ui-gdpr-components": "static-1.10625",
  "underscore": "static-1.8",
  "foundations-theming-base": "static-1.3724",
  "HeadJS": "static-2.793",
  "framer-motion": "static-1.76",
  "hs-test-utils-bend-plugin": "static-1.3409",
  "msw": "static-1.39",
  "testing-library": "static-1.156",
  "hs-locale-management": "static-1.270",
  "ui-fonts": "static-1.1018",
  "i18n-data": "static-1.229",
  "moment-timezone": "static-5.88",
  "jasmine": "static-4.4582",
  "csstype": "static-1.50",
  "quartz-head": "static-1.1078",
  "web-vitals": "static-1.12",
  "batch-promise": "static-1.1811",
  "external-options-client-types": "static-1.4317",
  "fast-json-stable-stringify": "static-1.4",
  "framework-data-schema-resolvers": "static-1.7160",
  "quartz-i18n": "static-1.1088",
  "frontend-preferences-client": "static-1.8191",
  "graphql": "static-1.86",
  "persist-promise": "static-1.3968",
  "reporting-client-types": "static-1.2661",
  "apollo-stack-hubspot": "static-3.91",
  "growth-payments-core": "static-1.26121",
  "hubspot-apollo-client": "static-1.5147",
  "foundations-components-legacy": "static-1-ech-accordiontransition-jank.20",
  "quartz-routing": "static-1.843",
  "hs-story-utils": "static-1.9695",
  "react-flip-move": "static-1.75",
  "nested-table": "static-1.502",
  "seat-types-lib": "static-1.664",
  "timezone-utils": "static-2.5512",
  "react-create-root-preference": "static-1.66",
  "bend-plugin-foundations-components": "static-1-ech-accordiontransition-jank.20",
  "floating-ui": "static-1.62",
  "react-aria": "static-1.70",
  "tanstack-table": "static-1.59",
  "opentelemetry-fe-types": "static-1.37",
  "dispatcher": "static-1.142",
  "general-store": "static-6.20",
  "mobile-manifest-mixins": "static-1.573",
  "module-federation": "static-1.30",
  "opentelemetry-fe": "static-1.412",
  "quartz-test": "static-1.1088",
  "quartz-tracking": "static-1.792",
  "bend-plugin-chirp-manifest": "static-1.343",
  "chirp-fetch": "static-1.2162",
  "merchandise-lib": "static-1.276",
  "purchase-motions-components": "static-1.6309",
  "salesImages": "static-1.532",
  "ts-schema": "static-1.4271",
  "bender-build-tools": "static-1.3411",
  "bend-plugin-foundations-theming": "static-1.3222",
  "restore-request-side-panel-lib": "static-1.1610",
  "react-immutable-render-mixin": "static-1.9",
  "apollo-link-hub-http": "static-2.4924",
  "conditional-properties-service-client": "static-1.3989",
  "crm-pipelines-api-client-types": "static-1.4325",
  "event-emitter": "static-1.1221",
  "fdsr-migration-layer": "static-1.279",
  "multi-currency-client-types": "static-1.3886",
  "getting-started-shared-tasks": "static-1.19175",
  "growth-data-modal": "static-1.5852",
  "growth-onboarding-confetti": "static-1.3331",
  "growth-onboarding-next-action-utils": "static-1.2639",
  "navigation-components": "static-1.18762",
  "onboarding-tours-client": "static-1.5286",
  "onboarding-tours-utils": "static-1.1138",
  "ui-shepherd-react": "static-3.10536",
  "ui-shepherd-tracker": "static-1.7917",
  "ui-universal-auth": "static-1.9342",
  "user-context": "static-1.5385",
  "bend-plugin-pulse": "static-1.399",
  "fast-json-patch": "static-1.67",
  "base-ui": "static-1.19",
  "react-day-picker": "static-1.7",
  "tanstack-virtual": "static-1.36",
  "hubspotter-http-shared-msw-handlers": "static-1.10564",
  "magpie-lib": "static-1.5734",
  "navigation-messaging": "static-1.8089",
  "amplitude-session-replay-browser": "static-1.60",
  "chatspot-core": "static-1.22787",
  "copilot-toolkit": "static-1.11795",
  "cms-field-types": "static-1.5082",
  "content-icons-ui": "static-1.2331",
  "integrations-lib": "static-1.16975",
  "calling-global-api": "static-1.65484",
  "calling-internal-common": "static-1.31586",
  "calling-lifecycle-internal": "static-1.66866",
  "calling-lifecycle-messages": "static-1.59160",
  "commerce-products-lib": "static-1.10467",
  "crm-index-visualization-core": "static-1.4501",
  "crm-links": "static-1.6597",
  "customer-data-properties-shared-msw-handlers": "static-1.9893",
  "file-manager-components": "static-1.24417",
  "formula-editor": "static-1.14705",
  "google-libphonenumber": "static-1.42",
  "inbounddb-objects-service-types": "static-1.4403",
  "meetings-icalendar-utils-lib": "static-1.904",
  "object-builder-ui-client": "static-1.49603",
  "pipeline-validation-client-types": "static-1.4160",
  "property-value-citations": "static-1.3110",
  "smart-data-capture-core": "static-1.75",
  "smart-property-lib": "static-1.8228",
  "tiered-pricing": "static-1.1908",
  "topics-actions-lib": "static-1.432",
  "trial-components-library": "static-1.14060",
  "ui-addon-iframeable": "static-1.9345",
  "zustand": "static-1.79",
  "final-form": "static-1.75",
  "redux-mock-store": "static-1.8",
  "redux-toolkit": "static-1.75",
  "rich-text-lib": "static-1.20264",
  "tinymce-themes": "static-1.57018",
  "data-token-picker": "static-1.16845",
  "hub-http-contrib": "static-1.3307",
  "interframe": "static-3.5024",
  "tinymce-data": "static-1.41133",
  "tinymce-plugins": "static-1.58162",
  "ui-addon-sales-email": "static-1.5481",
  "framework-data-schema-quick-fetch": "static-1.7065",
  "ui-addon-opt": "static-4.8632",
  "hubspot-apollo-cache": "static-1.606",
  "react-window": "static-1.13",
  "ts-utils-lib": "static-1.426",
  "opentelemetry-web": "static-1.11",
  "purchase-motions-api": "static-1.6312",
  "onboarding-data-sync-lib": "static-1.2450",
  "growth-onboarding-next-action-components": "static-1.2667",
  "user-context-client": "static-1.4778",
  "idb-keyval": "static-1.48",
  "magpie-types": "static-1.5194",
  "nest": "static-1.503",
  "reactive-lib": "static-1.988",
  "simple-logging-lib": "static-1.3319",
  "unified-auth-core-lib": "static-1.1138",
  "getting-started-shared-tasks-store": "static-1.18293",
  "markdown-it": "static-1.6",
  "breeze-engine-lib": "static-1.1635",
  "integrations-error-boundary-lib": "static-1.14390",
  "integrations-tracking-lib": "static-1.5876",
  "native-integrations-shared-strings": "static-1.8047",
  "redux-observable": "static-1.72",
  "ReduxMessenger": "static-2.10638",
  "rxjs": "static-5.10",
  "unified-auth": "static-1.856",
  "calling-error-reporting": "static-1.31593",
  "shared-worker-versioning": "static-1.11308",
  "calling-usage-tracker": "static-1.6805",
  "voice-sms-access-library": "static-1.1965",
  "customer-data-tracking": "static-1.7149",
  "commerce-permissions": "static-1.1046",
  "products-iframe-lib": "static-1.8537",
  "products-ui-components-shared-msw-handlers": "static-1.10948",
  "crm-index-associations-lib": "static-1.6709",
  "framework-data-schema-resolvers-shared-msw-handlers": "static-1.10649",
  "sales-views-client-types": "static-1.4523",
  "location-customization-utils-lib": "static-1.10039",
  "apollo-dlb": "static-3.86",
  "immerable": "static-1.4419",
  "video-components-external": "static-1.12100",
  "video-data-lib": "static-1.35758",
  "bark-lib": "static-1.16781",
  "browser-prettier": "static-1.11",
  "codemirror": "static-5.99",
  "crm-properties-common-lib": "static-1.6157",
  "react-codemirror": "static-1.10907",
  "data-agent-kit": "static-1.603",
  "feedback-loader": "static-1.29767",
  "fsm": "static-1.4013",
  "policy-lib": "static-1.7065",
  "react-colorpicker": "static-2.10476",
  "reference-resolvers-lite-shared-msw-handlers": "static-1.10712",
  "embedded-academy-lib": "static-1.15445",
  "hubs-service-types": "static-1.1525",
  "FileManagerLib": "static-1.40057",
  "NamespacedHubStyle": "static-2.9240",
  "FileManagerCore": "static-1.39916",
  "content-assistance-lib": "static-1.8159",
  "layout-dnd-components": "static-1.12921",
  "layout-dnd-utils": "static-1.11896",
  "ui-addon-emoji-picker": "static-1.10154",
  "ui-brand-identity-lib": "static-1.16350",
  "InboxConnectUtils": "static-4.15503",
  "meetings-connect-utils-lib": "static-1.7876",
  "breeze-engine-chat-components": "static-1.613",
  "breeze-engine-core": "static-1.913",
  "ably": "static-2.2",
  "highlight.js": "static-1.83",
  "universal-page-editor-lib": "static-1.3276",
  "adobe-sign-auth-lib": "static-1.407",
  "ads-unified-auth-lib": "static-1.1195",
  "google-sheets-integration-lib": "static-1.975",
  "microsoft-drive-auth-lib": "static-1.74",
  "surveymonkey-integration-lib": "static-1.420",
  "slack-ui-library": "static-1.10666",
  "calling-orchestration-schema": "static-1.36742",
  "crm-record-cards-service-types": "static-1.3762",
  "content-media-composition-data-lib": "static-1.13176",
  "content-media-compositions": "static-2.17183",
  "media-bridge-lib": "static-1.19365",
  "diff-match-patch": "static-1.7",
  "react-reducer-toolkit": "static-1.16310",
  "browser-eslint": "static-2.57",
  "trellis-story-utils": "static-1.4776",
  "storybook-react": "static-1.37",
  "academy-common-lib": "static-1.14905",
  "audio-components": "static-1.6300",
  "FileManagerImages": "static-1.37568",
  "video-components": "static-1.14102",
  "breeze-artifacts-sdk": "static-1.249",
  "cropperjs": "static-1.10",
  "html-to-image": "static-1.58",
  "urlinator": "static-1.4801",
  "video-embed": "static-1.36592",
  "ui-addon-video-player": "static-1.8970",
  "ui-coaching-tips": "static-1.29255",
  "ContentData": "static-1.69145",
  "layout-data-lib": "static-1.10221",
  "academy-service-client": "static-1.3956",
  "croppie": "static-2.10",
  "SafeStorage": "static-1.4671",
  "trellis-ecosystem": "static-1.7588",
  "ui-addon-react-router-dom": "static-1.9806",
  "wootric-nps": "static-1.7177",
  "social-insights-client-types": "static-1.22685",
  "outpost": "static-1.4426",
  "growth-onboarding-feedback-components": "static-1.6852",
  "advanced-menus-core": "static-1.15536",
  "advanced-menus-lib": "static-1.12414",
  "ExportDialog": "static-6.10647",
  "ui-memberships-settings-lib": "static-1.34787",
  "marketplace-ui-apps-core": "static-1.19189",
  "marketplace-ui-common": "static-1.20657",
  "seamless-immutable": "static-7.6",
  "simple-menus-core": "static-1.15535",
  "simple-menus-lib": "static-1.17052",
  "developer-experience-shared-components": "static-1.10772",
  "immutable-less": "static-1.4919",
  "marketplace-ui-client-types": "static-1.18064",
  "ui-addon-integrations-directory-panel": "static-2.8292",
  "ui-extensibility-client-types": "static-1.4186",
  "ai-settings-ui-library": "static-1.8281",
  "nav-meta": "static-1.30399",
  "ui-product-approvals-common": "static-1.956",
  "apps-service-types": "static-1.4009",
  "oauth-service-types": "static-1.4507",
  "simple-data-table": "static-1.3481"
},
  depPathPrefixes: {
  "documents-public-ui": "/documents-public-ui/static-1.35169",
  "atom": "/atom/static-1.5354",
  "autolinker": "/autolinker/static-3.11",
  "avatar-components": "/avatar-components/static-1.2762",
  "client-types": "/client-types/static-1.496",
  "cssUtils": "/cssUtils/static-1.888",
  "customer-data-filters-ui": "/customer-data-filters-ui/static-1.40823",
  "customer-data-objects": "/customer-data-objects/static-1.7956",
  "customer-data-property-utils": "/customer-data-property-utils/static-1.8370",
  "documents-lib": "/documents-lib/static-1.35174",
  "emoji-mart": "/emoji-mart/static-3.4",
  "flux-actions": "/flux-actions/static-1.364",
  "FormsCommonComponents": "/FormsCommonComponents/static-1.86506",
  "FormUrlGenerator": "/FormUrlGenerator/static-2.4995",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.2455",
  "googlemaps-react-wrapper": "/googlemaps-react-wrapper/static-1.3",
  "head-dlb": "/head-dlb/static-1.5007",
  "highcharts": "/highcharts/static-8.108",
  "hs-lodash": "/hs-lodash/static-4.45",
  "hs-promise-utils": "/hs-promise-utils/static-1.5865",
  "hs-test-utils": "/hs-test-utils/static-1.8298",
  "hub-http": "/hub-http/static-1.6481",
  "hubspot-dlb": "/hubspot-dlb/static-2.1882",
  "HubStyle": "/HubStyle/static-2.12063",
  "HubStyleTokens": "/HubStyleTokens/static-2.11756",
  "I18n": "/I18n/static-7.1667",
  "icons": "/icons/static-2.677",
  "jasmine-immutable": "/jasmine-immutable/static-1.3289",
  "jasmine-runner": "/jasmine-runner/static-1.6721",
  "js-cookie": "/js-cookie/static-1.18",
  "laboratory-lib": "/laboratory-lib/static-3.7420",
  "lodash": "/lodash/static-1.3",
  "PatternValidationJS": "/PatternValidationJS/static-1.3163",
  "pdf-js": "/pdf-js/static-2.49",
  "property-translator": "/property-translator/static-1.5666",
  "quartz": "/quartz/static-1.7413",
  "react": "/react/static-7.192",
  "react-dlb": "/react-dlb/static-1.88",
  "react-dnd": "/react-dnd/static-3.19",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-3.7",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "react-redux": "/react-redux/static-7.75",
  "react-rhumb": "/react-rhumb/static-1-fkhalid-delete-fcp-cls-subscribers.4",
  "react-select-plus": "/react-select-plus/static-1.109",
  "react-utils": "/react-utils/static-2.5534",
  "react-virtualized": "/react-virtualized/static-2.104",
  "reference-resolvers": "/reference-resolvers/static-1.8450",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.8372",
  "reporting-data": "/reporting-data/static-1.68696",
  "reporting-reports": "/reporting-reports/static-1.68373",
  "reporting-snowflake": "/reporting-snowflake/static-1.57313",
  "reporting-testing-lib": "/reporting-testing-lib/static-1.10629",
  "reporting-visualizations": "/reporting-visualizations/static-1.60771",
  "reselect": "/reselect/static-3.9",
  "sales-content-partitioning": "/sales-content-partitioning/static-1.9219",
  "sanitize": "/sanitize/static-1.4742",
  "sanitize-text": "/sanitize-text/static-1.8421",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.182",
  "SharedLegalStrings": "/SharedLegalStrings/static-1.2016",
  "signup-constants": "/signup-constants/static-1.19553",
  "signup-ui-url-generator": "/signup-ui-url-generator/static-2.8330",
  "StyleGuideUI": "/StyleGuideUI/static-3.499",
  "superstore": "/superstore/static-1.5026",
  "tinymce": "/tinymce/static-6.5",
  "transmute": "/transmute/static-2.85",
  "ui-addon-draggable": "/ui-addon-draggable/static-3.5026",
  "ui-addon-form-validation": "/ui-addon-form-validation/static-1.11251",
  "ui-asset-management-lib": "/ui-asset-management-lib/static-1.11366",
  "ui-images": "/ui-images/static-2.1238",
  "UIComponents": "/UIComponents/static-3.8702",
  "usage-tracker": "/usage-tracker/static-1.7624",
  "usage-tracker-container": "/usage-tracker-container/static-1.7614",
  "usage-tracker-core": "/usage-tracker-core/static-1.7474",
  "viral-links-lib": "/viral-links-lib/static-1.7344",
  "webpack-env": "/webpack-env/static-1.54",
  "data-fetching-client": "/data-fetching-client/static-1.9926",
  "foundations-components": "/foundations-components/static-1-ech-accordiontransition-jank.20",
  "immutable": "/immutable/static-2.83",
  "isMobile": "/isMobile/static-1.7",
  "PortalIdParser": "/PortalIdParser/static-2.404",
  "quartz-config": "/quartz-config/static-1.1191",
  "quartz-core": "/quartz-core/static-1.6632",
  "quick-fetch": "/quick-fetch/static-1.4109",
  "raven": "/raven/static-3.5925",
  "redux": "/redux/static-4.76",
  "redux-thunk": "/redux-thunk/static-2.77",
  "rpc-client-utils": "/rpc-client-utils/static-1.4933",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.11414",
  "ui-addon-upgrades": "/ui-addon-upgrades/static-9.18342",
  "enviro": "/enviro/static-4.455",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5587",
  "raven-hubspot": "/raven-hubspot/static-1.6232",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.4297",
  "metrics-js": "/metrics-js/static-1.9867",
  "styled-components": "/styled-components/static-2.95",
  "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.3596",
  "moment": "/moment/static-3.26",
  "react-dom": "/react-dom/static-7.85",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.3690",
  "quartz-webpack": "/quartz-webpack/static-1.3637",
  "foundations-assets": "/foundations-assets/static-1.5151",
  "foundations-theming": "/foundations-theming/static-1.4739",
  "hub-http-janus": "/hub-http-janus/static-1.873",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.10566",
  "hubspotter-http": "/hubspotter-http/static-1.4842",
  "sassPrefix": "/sassPrefix/static-1.163",
  "conversations-skeleton-state": "/conversations-skeleton-state/static-1.7514",
  "crm-message-bus": "/crm-message-bus/static-1.43695",
  "customer-data-filters-ui-msw-helpers": "/customer-data-filters-ui-msw-helpers/static-1.23258",
  "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.13299",
  "customer-data-reference-ui-components": "/customer-data-reference-ui-components/static-1.13447",
  "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.10097",
  "events-data-lib": "/events-data-lib/static-1.510",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.4199",
  "hs-resources": "/hs-resources/static-1.459",
  "immer": "/immer/static-1.94",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3718",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.4034",
  "multi-account-reference-resolvers": "/multi-account-reference-resolvers/static-1.1268",
  "onboarding-scopes": "/onboarding-scopes/static-1.6721",
  "onboarding-tours": "/onboarding-tours/static-1.17072",
  "pulse": "/pulse/static-1.896",
  "reporting-datasets-permissions-lib": "/reporting-datasets-permissions-lib/static-1.14411",
  "stylex": "/stylex/static-1.38",
  "trellis-assets": "/trellis-assets/static-1.2548",
  "trellis-components": "/trellis-components/static-1.2567",
  "trellis-theming": "/trellis-theming/static-1.1237",
  "ui-addon-teams": "/ui-addon-teams/static-1.21875",
  "quartz-auth": "/quartz-auth/static-1.1088",
  "ui-business-units-lib": "/ui-business-units-lib/static-1.9355",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.5310",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.9650",
  "ContentUtils": "/ContentUtils/static-1.69070",
  "customer-data-properties": "/customer-data-properties/static-1.52496",
  "forms-ai-lib": "/forms-ai-lib/static-1.4721",
  "forms-utils-lib": "/forms-utils-lib/static-1.13053",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1-ech-accordiontransition-jank.20",
  "react-dnd-compat": "/react-dnd-compat/static-1.4885",
  "react-tinymce": "/react-tinymce/static-1.55922",
  "tinymce-config": "/tinymce-config/static-2.55048",
  "ui-gdpr-components": "/ui-gdpr-components/static-1.10625",
  "underscore": "/underscore/static-1.8",
  "foundations-theming-base": "/foundations-theming-base/static-1.3724",
  "HeadJS": "/HeadJS/static-2.793",
  "framer-motion": "/framer-motion/static-1.76",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.3409",
  "msw": "/msw/static-1.39",
  "testing-library": "/testing-library/static-1.156",
  "hs-locale-management": "/hs-locale-management/static-1.270",
  "ui-fonts": "/ui-fonts/static-1.1018",
  "i18n-data": "/i18n-data/static-1.229",
  "moment-timezone": "/moment-timezone/static-5.88",
  "jasmine": "/jasmine/static-4.4582",
  "csstype": "/csstype/static-1.50",
  "quartz-head": "/quartz-head/static-1.1078",
  "web-vitals": "/web-vitals/static-1.12",
  "batch-promise": "/batch-promise/static-1.1811",
  "external-options-client-types": "/external-options-client-types/static-1.4317",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.7160",
  "quartz-i18n": "/quartz-i18n/static-1.1088",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.8191",
  "graphql": "/graphql/static-1.86",
  "persist-promise": "/persist-promise/static-1.3968",
  "reporting-client-types": "/reporting-client-types/static-1.2661",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.91",
  "growth-payments-core": "/growth-payments-core/static-1.26121",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.5147",
  "foundations-components-legacy": "/foundations-components-legacy/static-1-ech-accordiontransition-jank.20",
  "quartz-routing": "/quartz-routing/static-1.843",
  "hs-story-utils": "/hs-story-utils/static-1.9695",
  "react-flip-move": "/react-flip-move/static-1.75",
  "nested-table": "/nested-table/static-1.502",
  "seat-types-lib": "/seat-types-lib/static-1.664",
  "timezone-utils": "/timezone-utils/static-2.5512",
  "react-create-root-preference": "/react-create-root-preference/static-1.66",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1-ech-accordiontransition-jank.20",
  "floating-ui": "/floating-ui/static-1.62",
  "react-aria": "/react-aria/static-1.70",
  "tanstack-table": "/tanstack-table/static-1.59",
  "opentelemetry-fe-types": "/opentelemetry-fe-types/static-1.37",
  "dispatcher": "/dispatcher/static-1.142",
  "general-store": "/general-store/static-6.20",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.573",
  "module-federation": "/module-federation/static-1.30",
  "opentelemetry-fe": "/opentelemetry-fe/static-1.412",
  "quartz-test": "/quartz-test/static-1.1088",
  "quartz-tracking": "/quartz-tracking/static-1.792",
  "bend-plugin-chirp-manifest": "/bend-plugin-chirp-manifest/static-1.343",
  "chirp-fetch": "/chirp-fetch/static-1.2162",
  "merchandise-lib": "/merchandise-lib/static-1.276",
  "purchase-motions-components": "/purchase-motions-components/static-1.6309",
  "salesImages": "/salesImages/static-1.532",
  "ts-schema": "/ts-schema/static-1.4271",
  "bender-build-tools": "/bender-build-tools/static-1.3411",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.3222",
  "restore-request-side-panel-lib": "/restore-request-side-panel-lib/static-1.1610",
  "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.4924",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.3989",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.4325",
  "event-emitter": "/event-emitter/static-1.1221",
  "fdsr-migration-layer": "/fdsr-migration-layer/static-1.279",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.3886",
  "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.19175",
  "growth-data-modal": "/growth-data-modal/static-1.5852",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.3331",
  "growth-onboarding-next-action-utils": "/growth-onboarding-next-action-utils/static-1.2639",
  "navigation-components": "/navigation-components/static-1.18762",
  "onboarding-tours-client": "/onboarding-tours-client/static-1.5286",
  "onboarding-tours-utils": "/onboarding-tours-utils/static-1.1138",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.10536",
  "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.7917",
  "ui-universal-auth": "/ui-universal-auth/static-1.9342",
  "user-context": "/user-context/static-1.5385",
  "bend-plugin-pulse": "/bend-plugin-pulse/static-1.399",
  "fast-json-patch": "/fast-json-patch/static-1.67",
  "base-ui": "/base-ui/static-1.19",
  "react-day-picker": "/react-day-picker/static-1.7",
  "tanstack-virtual": "/tanstack-virtual/static-1.36",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.10564",
  "magpie-lib": "/magpie-lib/static-1.5734",
  "navigation-messaging": "/navigation-messaging/static-1.8089",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.60",
  "chatspot-core": "/chatspot-core/static-1.22787",
  "copilot-toolkit": "/copilot-toolkit/static-1.11795",
  "cms-field-types": "/cms-field-types/static-1.5082",
  "content-icons-ui": "/content-icons-ui/static-1.2331",
  "integrations-lib": "/integrations-lib/static-1.16975",
  "calling-global-api": "/calling-global-api/static-1.65484",
  "calling-internal-common": "/calling-internal-common/static-1.31586",
  "calling-lifecycle-internal": "/calling-lifecycle-internal/static-1.66866",
  "calling-lifecycle-messages": "/calling-lifecycle-messages/static-1.59160",
  "commerce-products-lib": "/commerce-products-lib/static-1.10467",
  "crm-index-visualization-core": "/crm-index-visualization-core/static-1.4501",
  "crm-links": "/crm-links/static-1.6597",
  "customer-data-properties-shared-msw-handlers": "/customer-data-properties-shared-msw-handlers/static-1.9893",
  "file-manager-components": "/file-manager-components/static-1.24417",
  "formula-editor": "/formula-editor/static-1.14705",
  "google-libphonenumber": "/google-libphonenumber/static-1.42",
  "inbounddb-objects-service-types": "/inbounddb-objects-service-types/static-1.4403",
  "meetings-icalendar-utils-lib": "/meetings-icalendar-utils-lib/static-1.904",
  "object-builder-ui-client": "/object-builder-ui-client/static-1.49603",
  "pipeline-validation-client-types": "/pipeline-validation-client-types/static-1.4160",
  "property-value-citations": "/property-value-citations/static-1.3110",
  "smart-data-capture-core": "/smart-data-capture-core/static-1.75",
  "smart-property-lib": "/smart-property-lib/static-1.8228",
  "tiered-pricing": "/tiered-pricing/static-1.1908",
  "topics-actions-lib": "/topics-actions-lib/static-1.432",
  "trial-components-library": "/trial-components-library/static-1.14060",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.9345",
  "zustand": "/zustand/static-1.79",
  "final-form": "/final-form/static-1.75",
  "redux-mock-store": "/redux-mock-store/static-1.8",
  "redux-toolkit": "/redux-toolkit/static-1.75",
  "rich-text-lib": "/rich-text-lib/static-1.20264",
  "tinymce-themes": "/tinymce-themes/static-1.57018",
  "data-token-picker": "/data-token-picker/static-1.16845",
  "hub-http-contrib": "/hub-http-contrib/static-1.3307",
  "interframe": "/interframe/static-3.5024",
  "tinymce-data": "/tinymce-data/static-1.41133",
  "tinymce-plugins": "/tinymce-plugins/static-1.58162",
  "ui-addon-sales-email": "/ui-addon-sales-email/static-1.5481",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.7065",
  "ui-addon-opt": "/ui-addon-opt/static-4.8632",
  "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.606",
  "react-window": "/react-window/static-1.13",
  "ts-utils-lib": "/ts-utils-lib/static-1.426",
  "opentelemetry-web": "/opentelemetry-web/static-1.11",
  "purchase-motions-api": "/purchase-motions-api/static-1.6312",
  "onboarding-data-sync-lib": "/onboarding-data-sync-lib/static-1.2450",
  "growth-onboarding-next-action-components": "/growth-onboarding-next-action-components/static-1.2667",
  "user-context-client": "/user-context-client/static-1.4778",
  "idb-keyval": "/idb-keyval/static-1.48",
  "magpie-types": "/magpie-types/static-1.5194",
  "nest": "/nest/static-1.503",
  "reactive-lib": "/reactive-lib/static-1.988",
  "simple-logging-lib": "/simple-logging-lib/static-1.3319",
  "unified-auth-core-lib": "/unified-auth-core-lib/static-1.1138",
  "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.18293",
  "markdown-it": "/markdown-it/static-1.6",
  "breeze-engine-lib": "/breeze-engine-lib/static-1.1635",
  "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.14390",
  "integrations-tracking-lib": "/integrations-tracking-lib/static-1.5876",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.8047",
  "redux-observable": "/redux-observable/static-1.72",
  "ReduxMessenger": "/ReduxMessenger/static-2.10638",
  "rxjs": "/rxjs/static-5.10",
  "unified-auth": "/unified-auth/static-1.856",
  "calling-error-reporting": "/calling-error-reporting/static-1.31593",
  "shared-worker-versioning": "/shared-worker-versioning/static-1.11308",
  "calling-usage-tracker": "/calling-usage-tracker/static-1.6805",
  "voice-sms-access-library": "/voice-sms-access-library/static-1.1965",
  "customer-data-tracking": "/customer-data-tracking/static-1.7149",
  "commerce-permissions": "/commerce-permissions/static-1.1046",
  "products-iframe-lib": "/products-iframe-lib/static-1.8537",
  "products-ui-components-shared-msw-handlers": "/products-ui-components-shared-msw-handlers/static-1.10948",
  "crm-index-associations-lib": "/crm-index-associations-lib/static-1.6709",
  "framework-data-schema-resolvers-shared-msw-handlers": "/framework-data-schema-resolvers-shared-msw-handlers/static-1.10649",
  "sales-views-client-types": "/sales-views-client-types/static-1.4523",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.10039",
  "apollo-dlb": "/apollo-dlb/static-3.86",
  "immerable": "/immerable/static-1.4419",
  "video-components-external": "/video-components-external/static-1.12100",
  "video-data-lib": "/video-data-lib/static-1.35758",
  "bark-lib": "/bark-lib/static-1.16781",
  "browser-prettier": "/browser-prettier/static-1.11",
  "codemirror": "/codemirror/static-5.99",
  "crm-properties-common-lib": "/crm-properties-common-lib/static-1.6157",
  "react-codemirror": "/react-codemirror/static-1.10907",
  "data-agent-kit": "/data-agent-kit/static-1.603",
  "feedback-loader": "/feedback-loader/static-1.29767",
  "fsm": "/fsm/static-1.4013",
  "policy-lib": "/policy-lib/static-1.7065",
  "react-colorpicker": "/react-colorpicker/static-2.10476",
  "reference-resolvers-lite-shared-msw-handlers": "/reference-resolvers-lite-shared-msw-handlers/static-1.10712",
  "embedded-academy-lib": "/embedded-academy-lib/static-1.15445",
  "hubs-service-types": "/hubs-service-types/static-1.1525",
  "FileManagerLib": "/FileManagerLib/static-1.40057",
  "NamespacedHubStyle": "/NamespacedHubStyle/static-2.9240",
  "FileManagerCore": "/FileManagerCore/static-1.39916",
  "content-assistance-lib": "/content-assistance-lib/static-1.8159",
  "layout-dnd-components": "/layout-dnd-components/static-1.12921",
  "layout-dnd-utils": "/layout-dnd-utils/static-1.11896",
  "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.10154",
  "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.16350",
  "InboxConnectUtils": "/InboxConnectUtils/static-4.15503",
  "meetings-connect-utils-lib": "/meetings-connect-utils-lib/static-1.7876",
  "breeze-engine-chat-components": "/breeze-engine-chat-components/static-1.613",
  "breeze-engine-core": "/breeze-engine-core/static-1.913",
  "ably": "/ably/static-2.2",
  "highlight.js": "/highlight.js/static-1.83",
  "universal-page-editor-lib": "/universal-page-editor-lib/static-1.3276",
  "adobe-sign-auth-lib": "/adobe-sign-auth-lib/static-1.407",
  "ads-unified-auth-lib": "/ads-unified-auth-lib/static-1.1195",
  "google-sheets-integration-lib": "/google-sheets-integration-lib/static-1.975",
  "microsoft-drive-auth-lib": "/microsoft-drive-auth-lib/static-1.74",
  "surveymonkey-integration-lib": "/surveymonkey-integration-lib/static-1.420",
  "slack-ui-library": "/slack-ui-library/static-1.10666",
  "calling-orchestration-schema": "/calling-orchestration-schema/static-1.36742",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3762",
  "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.13176",
  "content-media-compositions": "/content-media-compositions/static-2.17183",
  "media-bridge-lib": "/media-bridge-lib/static-1.19365",
  "diff-match-patch": "/diff-match-patch/static-1.7",
  "react-reducer-toolkit": "/react-reducer-toolkit/static-1.16310",
  "browser-eslint": "/browser-eslint/static-2.57",
  "trellis-story-utils": "/trellis-story-utils/static-1.4776",
  "storybook-react": "/storybook-react/static-1.37",
  "academy-common-lib": "/academy-common-lib/static-1.14905",
  "audio-components": "/audio-components/static-1.6300",
  "FileManagerImages": "/FileManagerImages/static-1.37568",
  "video-components": "/video-components/static-1.14102",
  "breeze-artifacts-sdk": "/breeze-artifacts-sdk/static-1.249",
  "cropperjs": "/cropperjs/static-1.10",
  "html-to-image": "/html-to-image/static-1.58",
  "urlinator": "/urlinator/static-1.4801",
  "video-embed": "/video-embed/static-1.36592",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.8970",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.29255",
  "ContentData": "/ContentData/static-1.69145",
  "layout-data-lib": "/layout-data-lib/static-1.10221",
  "academy-service-client": "/academy-service-client/static-1.3956",
  "croppie": "/croppie/static-2.10",
  "SafeStorage": "/SafeStorage/static-1.4671",
  "trellis-ecosystem": "/trellis-ecosystem/static-1.7588",
  "ui-addon-react-router-dom": "/ui-addon-react-router-dom/static-1.9806",
  "wootric-nps": "/wootric-nps/static-1.7177",
  "social-insights-client-types": "/social-insights-client-types/static-1.22685",
  "outpost": "/outpost/static-1.4426",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.6852",
  "advanced-menus-core": "/advanced-menus-core/static-1.15536",
  "advanced-menus-lib": "/advanced-menus-lib/static-1.12414",
  "ExportDialog": "/ExportDialog/static-6.10647",
  "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.34787",
  "marketplace-ui-apps-core": "/marketplace-ui-apps-core/static-1.19189",
  "marketplace-ui-common": "/marketplace-ui-common/static-1.20657",
  "seamless-immutable": "/seamless-immutable/static-7.6",
  "simple-menus-core": "/simple-menus-core/static-1.15535",
  "simple-menus-lib": "/simple-menus-lib/static-1.17052",
  "developer-experience-shared-components": "/developer-experience-shared-components/static-1.10772",
  "immutable-less": "/immutable-less/static-1.4919",
  "marketplace-ui-client-types": "/marketplace-ui-client-types/static-1.18064",
  "ui-addon-integrations-directory-panel": "/ui-addon-integrations-directory-panel/static-2.8292",
  "ui-extensibility-client-types": "/ui-extensibility-client-types/static-1.4186",
  "ai-settings-ui-library": "/ai-settings-ui-library/static-1.8281",
  "nav-meta": "/nav-meta/static-1.30399",
  "ui-product-approvals-common": "/ui-product-approvals-common/static-1.956",
  "apps-service-types": "/apps-service-types/static-1.4009",
  "oauth-service-types": "/oauth-service-types/static-1.4507",
  "simple-data-table": "/simple-data-table/static-1.3481"
}
};
